export const processedModelsByAssetIdCustom = /* GraphQL */ `
  query ProcessedModelsByAssetId(
    $assetId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelProcessedModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    processedModelsByAssetId(
      assetId: $assetId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        assetId
        label
        description
        routeShort
        routeLong
        displayType
        modelType
        schema
        owner
        organizationId
        additionalDataPoints {
          id
          name
          parameterId
          source
          schema
          lookbackDays
          color
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const assetAlertsByAssetGroupIdAndAssetIdCustom = /* GraphQL */ `
  query AssetAlertsByAssetGroupIdAndAssetId(
    $assetGroupId: ID!
    $assetId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAssetAlertFilterInput
    $limit: Int
    $nextToken: String
  ) {
    assetAlertsByAssetGroupIdAndAssetId(
      assetGroupId: $assetGroupId
      assetId: $assetId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        occurenceKey
        name
        description
        rainfall
        period
        window
        assetId
        asset {
          id
          name
        }
        emails
        phoneNumbers
        active
        groupAlert
        lastRun
        dataSource
        probability
        assetGroupId
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;

//CRAIG newHire delete this
export const listAssetAlertsCustom = /* GraphQL */ `
  query ListAssetAlerts(
    $filter: ModelAssetAlertFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAssetAlerts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        occurenceKey
        name
        description
        rainfall
        period
        window
        assetId
        asset {
          id
          name
        }
        emails
        phoneNumbers
        active
        groupAlert
        dataSource
        probability
        lastRun
        assetGroupId
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listPerformanceCurvesCustom = /* GraphQL */ `
  query ListPerformanceCurves(
    $filter: ModelPerformanceCurveFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPerformanceCurves(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        curveData {
          #need this to get curve data
          x
          y
        }
        xUnit
        yUnit
        organizationId
        organizationIds
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const geoPointsByAssetGroupIdCustom = /* GraphQL */ `
  query GeoPointsByAssetGroupIdAndName(
    $assetGroupId: ID!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelGeoPointFilterInput
    $limit: Int
    $nextToken: String
  ) {
    geoPointsByAssetGroupIdAndName(
      assetGroupId: $assetGroupId
      sortDirection: $sortDirection
      name: $name
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        lat
        lng
        client
        elevation
        organizationId
        geojson
        imageUrl
        icon
        displayedChannels
        processedModels {
        items {
          id
          label
          routeShort
          routeLong
          displayType
          modelType
          schema
          additionalDataPoints {
            id
            name
            parameterId
            source
            schema
            lookbackDays
            color
            __typename
          }
        }
      }
        linkedComposedForecasts {
          items {
            id
            composedForecastID
            icon
            isDefault
            composedForecast {
              id
              name
              description
              forecastType
              isActive
              dataSources {
                items {
                  id
                  composedForecastId
                  sourceType
                  sourceName
                  sourceDescription
                  processedModelOutputId
                  processedModelOutput {
                    id
                    name
                    description
                    unit
                    outputLocation
                    active
                    schemaId
                    schema {
                      id
                      name
                      type
                      schemaType
                    }
                  }
                  postgresTable
                  postgresColumns
                  postgresAggregation
                  weight
                  priority
                  timeAlignment
                  temporalResolution
                  fallbackStrategy
                  isActive
                  metadata
                  dataOperations
                  __typename
                }
              }
              __typename
            }
            __typename
          }
          __typename
        }
        description
        assetGroupId
        precipCurveId
        windCurveId
        windCurve {
          id
          name
          description
          curveData {
            x
            y
          }
          xUnit
          yUnit
          createdAt
          updatedAt
          owner
          __typename
        }
        solarCurveId
        solarCurve {
          id
          name
          description
          xUnit
          yUnit
          dcCap
          acCap
          panelEfficiency
          thermalLoss
          minIrradiance
          trackingType
          arrayTilt
          arrayAzimuth
          maxTilt
          groundCoverRatio
        }
        createdAt
        updatedAt
        userGeoPointsId
        owner
        value {
          value
          currency
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;

// Hopefully delete this later
// export const listUsersCustom = /* GraphQL */ `
//   query ListUsers(
//     $filter: ModelUserFilterInput
//     $limit: Int
//     $nextToken: String
//   ) {
//     listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
//       items {
//         id
//         username
//         email
//         name
//         createdAt
//         updatedAt
//         organizations
//         cognitoIdentityId
//         profilePictureUrl
//         assetGroupCount  
//         assetCount
//         __typename
//       }
//       nextToken
//       __typename
//     }
//   }
// `;
export const getUserCustom = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      username
      email
      name
      profilePictureUrl
      cognitoIdentityId
      assetGroupCount
      assetCount
      termsAndConditionsReviewed
      termsAndConditionsLocation
      chatPrivacyPolicyAccepted
      chatPrivacyPolicyLocation
      termsAndConditionsAuditTrail
      privacyPolicyAuditTrail
      userConsent
      tourWelcomeShown
      tourChatCompleted
      tourGroupSeen
      tourAssetSeen
      tourOnboardingGuidanceSent
      preferredPersonaId
      createdAt
      updatedAt
      __typename
    }
  }
`;

// gets all assetGroups and nested Assets
export const fetchGroupsAndNestedAssetsCustom = /* GraphQL */ `
  query ListAssetGroups(
    $filter: ModelAssetGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAssetGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        profilePictureUrl
        description
        displayedChannels
        createdAt
        updatedAt
        organizationId
        userAssetGroupsId
        # AppSync caps a nested connection at 100 unless asked
        assets(limit: 500) {
          items {
        id
        name
        geojson
        imageUrl
        icon
        lat
        lng
        client
        elevation
        organizationId
        displayedChannels
        processedModels {
        items {
          id
          label
          routeShort
          routeLong
          displayType
          modelType
          schema
          additionalDataPoints {
            id
            name
            parameterId
            source
            schema
            lookbackDays
            color
            __typename
          }
        }
      }
        linkedComposedForecasts {
          items {
            id
            composedForecastID
            icon
            isDefault
            composedForecast {
              id
              name
              description
              forecastType
              isActive
              dataSources {
                items {
                  id
                  composedForecastId
                  sourceType
                  sourceName
                  sourceDescription
                  processedModelOutputId
                  processedModelOutput {
                    id
                    name
                    description
                    unit
                    outputLocation
                    active
                    schemaId
                    schema {
                      id
                      name
                      type
                      schemaType
                    }
                  }
                  postgresTable
                  postgresColumns
                  postgresAggregation
                  weight
                  priority
                  timeAlignment
                  temporalResolution
                  fallbackStrategy
                  isActive
                  metadata
                  dataOperations
                  __typename
                }
              }
              __typename
            }
            __typename
          }
          __typename
        }
        description
        assetGroupId
        precipCurveId
        windCurveId
        windCurve {
          id
          name
          description
          curveData {
            x
            y
          }
          xUnit
          yUnit
          createdAt
          updatedAt
          owner
          __typename
        }
        solarCurveId
        solarCurve {
          id
          name
          description
          xUnit
          yUnit
          dcCap
          acCap
          panelEfficiency
          thermalLoss
          minIrradiance
          trackingType
          arrayTilt
          arrayAzimuth
          maxTilt
          groundCoverRatio
        }
        createdAt
        updatedAt
        userGeoPointsId
        owner
        value {
          value
          currency
        }
        __typename
      }
        }
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listOrganizationsCustom = `query MyQuery {
  listOrganizations {
    items {
      name
      owner
      profilePictureUrl
      description
      id
      members {
        items {
          user {
            email
            name
            username
            profilePictureUrl
          }
        }
      }
    }
  }
}`

export const listOrganizationAndMembersCustom = /* GraphQL */  `query MyQuery {
  listOrganizations {
    items {
      description
      id
      name
      owner
      profilePictureUrl
      orgAiAnalystAccess
    }
  }
  listUserOrganizations {
    items {
      organizationId
      user {
        name
        organizationIds
        profilePictureUrl
        username
        id
        cognitoIdentityId
        email
      }
    }
  }
}`

// ProcessedModelSchema Custom Queries

export const processedModelSchemasByOrganization = /* GraphQL */ `
  query ProcessedModelSchemasByOrganization(
    $organizationId: String!
    $schemaTypeCreatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProcessedModelSchemaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    processedModelSchemasByOrganization(
      organizationId: $organizationId
      schemaTypeCreatedAt: $schemaTypeCreatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        type
        schemaType
        version
        executionUrl
        schemaFields
        dataSources
        runSchedule
        isActive
        activeStatus
        owner
        cognitoIdentityId
        organizationId
        s3BasePath
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const processedModelSchemasByActiveStatus = /* GraphQL */ `
  query ProcessedModelSchemasByActiveStatus(
    $activeStatus: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProcessedModelSchemaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    processedModelSchemasByActiveStatus(
      activeStatus: $activeStatus
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        type
        schemaType
        version
        executionUrl
        schemaFields
        dataSources
        runSchedule
        isActive
        activeStatus
        owner
        cognitoIdentityId
        organizationId
        s3BasePath
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

// Asset with ComposedForecasts
export const getAssetWithComposedForecasts = /* GraphQL */ `
  query GetAssetWithComposedForecasts($id: ID!) {
    getGeoPoint(id: $id) {
      id
      name
      lat
      lng
      elevation
      description
      organizationId
      owner
      composedForecasts {
        items {
          id
          name
          description
          forecastType
          aggregationMethod
          updateFrequency
          forecastHorizon
          isActive
          lastProcessed
          dataSources {
            items {
              id
              sourceName
              sourceDescription
              sourceType
              weight
              priority
              isActive
              processedModelOutputId
              processedModelOutput {
                id
                name
                description
                unit
                outputLocation
                active
                forecasts {
                  items {
                    id
                    forecastIssued
                    s3Key
                  }
                }
                schema {
                  id
                  name
                  type
                  schemaType
                }
              }
            }
          }
        }
      }
    }
  }
`;

// ProcessedModelSchemas with their OutputParams for dropdown
export const listProcessedModelSchemasWithOutputs = /* GraphQL */ `
  query ListProcessedModelSchemasWithOutputs(
    $filter: ModelProcessedModelSchemaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProcessedModelSchemas(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        type
        schemaType
        organizationId
        owner
        isActive
        modelKind
        outputs {
          items {
            id
            name
            description
            unit
            outputLocation
            active
            schemaId
            storageMode
            targetDatasetId
          }
        }
      }
      nextToken
    }
  }
`;

// Custom mutations for ComposedForecast without asset relationship to avoid GraphQL errors
export const createComposedForecastCustom = /* GraphQL */ `
  mutation CreateComposedForecast(
    $input: CreateComposedForecastInput!
    $condition: ModelComposedForecastConditionInput
  ) {
    createComposedForecast(input: $input, condition: $condition) {
      id
      name
      description
      forecastType
      aggregationMethod
      updateFrequency
      forecastHorizon
      outputParameters
      lastProcessed
      isActive
      processingSchedule
      validationThresholds
      owner
      organizationId
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const createComposedForecastDataSourceCustom = /* GraphQL */ `
  mutation CreateComposedForecastDataSource(
    $input: CreateComposedForecastDataSourceInput!
    $condition: ModelComposedForecastDataSourceConditionInput
  ) {
    createComposedForecastDataSource(input: $input, condition: $condition) {
      id
      composedForecastId
      sourceType
      sourceName
      sourceDescription
      processedModelOutputId
      # Intentionally NOT nesting the processedModelOutput object here.
      # For Dataset / Postgres sources processedModelOutputId is null, and the
      # belongsTo resolver returns an empty stub object whose required child
      # fields (id/name/schemaId) blow up GraphQL non-null validation. The
      # list query nests it safely for the read path; mutations only need to
      # confirm success and return scalar fields.
      postgresTable
      postgresColumns
      postgresAggregation
      weight
      priority
      timeAlignment
      temporalResolution
      fallbackStrategy
      isActive
      lastFetchedAt
      lastFetchStatus
      dataQualityScore
      metadata
      dataOperations
      owner
      organizationId
      createdAt
      updatedAt
      __typename
    }
  }
`;

// ProcessedModelSchemas with nested OutputParams and latest ForecastRecords
// Used by: fetchModelOutputSchemas, for the output detail modal on Data & Models
export const listProcessedModelSchemasWithForecastRecords = /* GraphQL */ `
  query ListProcessedModelSchemasWithForecastRecords(
    $filter: ModelProcessedModelSchemaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProcessedModelSchemas(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        type
        schemaType
        version
        executionUrl
        isActive
        activeStatus
        s3BasePath
        owner
        organizationId
        createdAt
        updatedAt
        outputs {
          items {
            id
            name
            description
            unit
            outputLocation
            active
            channels
            schemaId
            forecasts(sortDirection: DESC, limit: 10) {
              items {
                id
                forecastIssued
                s3Key
                metadata
              }
              nextToken
            }
          }
        }
      }
      nextToken
    }
  }
`;

// Load more ForecastRecords for a specific OutputParam (paginated)
export const forecastRecordsByOutputParam = /* GraphQL */ `
  query ForecastRecordsByOutputParam(
    $parameterId: ID!
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    forecastRecordsByParameterIdAndForecastIssued(
      parameterId: $parameterId
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        forecastIssued
        s3Key
        metadata
      }
      nextToken
    }
  }
`;

// TODO: REFACTOR - This query should eventually be integrated into Redux assetsSlice
// Current implementation: Direct GraphQL call in component (AssetBoundaryField)
// Future improvement: Update fetchGroupsAndNestedAssets in assetsSlice.ts to store group names
// and make this data available in Redux state, eliminating need for direct query in component
//
// Fetches asset groups with their assets that have geojson boundary data
// Used by: AssetBoundaryField component in SchemaFieldRenderer
export const fetchAssetGroupsWithBoundaryAssets = /* GraphQL */ `
  query FetchAssetGroupsWithBoundaryAssets(
    $filter: ModelAssetGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAssetGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        # AppSync caps a nested connection at 100 unless asked
        assets(limit: 500) {
          items {
            id
            name
            description
            lat
            lng
            geojson
          }
        }
      }
      nextToken
    }
  }
`;

// Lighter variant of the above for point locations — no geojson (boundary blobs
// can be large and the location picker only needs coordinates)
// Used by: AssetLocationField component in SchemaFieldRenderer
export const fetchAssetGroupsWithAssetPoints = /* GraphQL */ `
  query FetchAssetGroupsWithAssetPoints(
    $filter: ModelAssetGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAssetGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        # AppSync caps a nested connection at 100 unless asked
        assets(limit: 500) {
          items {
            id
            name
            description
            lat
            lng
          }
        }
      }
      nextToken
    }
  }
`;

// Full ProcessedModelSchema export query with linkedAssets, linkedAssetGroups, and outputs
export const getProcessedModelSchemaForExport = /* GraphQL */ `
  query GetProcessedModelSchemaForExport($id: ID!) {
    getProcessedModelSchema(id: $id) {
      id
      name
      description
      type
      schemaType
      version
      executionUrl
      schemaFields
      dataSources {
        items {
          id
          name
          sourceType
          s3Path
          databaseTable
          format
          metadata
          isGroundTruth
        }
        nextToken
      }
      runSchedule
      deliveryExpectation
      isActive
      activeStatus
      owner
      organizationId
      s3BasePath
      dependency
      linkedAssets {
        items {
          id
          assetID
          asset {
            id
            name
            lat
            lng
            geojson
          }
        }
        nextToken
      }
      linkedAssetGroups {
        items {
          id
          assetGroupID
          assetGroup {
            id
            name
          }
        }
        nextToken
      }
      outputs {
        items {
          id
          name
          description
          unit
          outputLocation
          active
          channels
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;

// Mirrors processedModelExecutorFunction's getProcessedModelSchemaWithOutputs selection set —
// used to build the "Post-Sample" download (the payload the executor POSTs to executionUrl).
// Keep in sync with amplify/backend/function/processedModelExecutorFunction/src/queries.js.
export const getProcessedModelSchemaForPostSample = /* GraphQL */ `
  query GetProcessedModelSchemaForPostSample($id: ID!) {
    getProcessedModelSchema(id: $id) {
      id
      name
      schemaType
      version
      modelKind
      historicalSettings
      schemaFields
      s3BasePath
      owner
      organizationId
      outputs {
        items {
          id
          name
          unit
          channels
          parameterTypeId
          outputLocation
          storageMode
          targetDatasetId
        }
      }
      linkedAssets {
        items {
          id
          assetID
          asset {
            id
            name
            lat
            lng
            geojson
          }
        }
      }
      linkedAssetGroups {
        items {
          id
          assetGroupID
          assetGroup {
            id
            name
            assets {
              items {
                id
                name
                lat
                lng
              }
            }
          }
        }
      }
      dataSources {
        items {
          id
          name
          sourceType
          s3Path
          databaseTable
          format
          metadata
          isGroundTruth
          dataOperations
        }
      }
    }
  }
`;

// Simple DataSetRecord query without nested dataset field to avoid auth issues
export const getDataSetRecordSimple = /* GraphQL */ `
  query GetDataSetRecord($id: ID!) {
    getDataSetRecord(id: $id) {
      id
      datasetId
      timeValue
      s3Path
      fileName
      uploadedAt
      fileSize
      compressedSize
      recordCount
      timeRange
      columns
      compressionType
      forecastHorizon
      organizationId
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;

// ===== Composed Forecast Management Queries =====

// List all ComposedForecasts with nested data sources
export const listComposedForecastsCustom = /* GraphQL */ `
  query ListComposedForecasts(
    $filter: ModelComposedForecastFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listComposedForecasts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        forecastType
        aggregationMethod
        updateFrequency
        forecastHorizon
        outputParameters
        isActive
        lastProcessed
        processingSchedule
        validationThresholds
        owner
        organizationId
        createdAt
        updatedAt
        linkedAssets {
          items {
            id
            assetID
            icon
            isDefault
            asset {
              id
              name
              assetGroupId
            }
          }
        }
        dataSources {
          items {
            id
            composedForecastId
            sourceType
            sourceName
            sourceDescription
            processedModelOutputId
            processedModelOutput {
              id
              name
              description
              unit
              outputLocation
              active
              schemaId
              storageMode
              targetDatasetId
              schema {
                id
                name
                type
                schemaType
                modelKind
              }
            }
            postgresTable
            postgresColumns
            postgresAggregation
            weight
            priority
            timeAlignment
            temporalResolution
            fallbackStrategy
            isActive
            lastFetchedAt
            lastFetchStatus
            dataQualityScore
            metadata
            dataOperations
            owner
            organizationId
            createdAt
            updatedAt
          }
        }
      }
      nextToken
    }
  }
`;

// Update a ComposedForecast (scalar fields only to avoid auth issues)
export const updateComposedForecastCustom = /* GraphQL */ `
  mutation UpdateComposedForecast(
    $input: UpdateComposedForecastInput!
    $condition: ModelComposedForecastConditionInput
  ) {
    updateComposedForecast(input: $input, condition: $condition) {
      id
      name
      description
      forecastType
      aggregationMethod
      updateFrequency
      forecastHorizon
      outputParameters
      lastProcessed
      isActive
      processingSchedule
      validationThresholds
      owner
      organizationId
      createdAt
      updatedAt
      __typename
    }
  }
`;

// Delete a ComposedForecast
export const deleteComposedForecastCustom = /* GraphQL */ `
  mutation DeleteComposedForecast(
    $input: DeleteComposedForecastInput!
    $condition: ModelComposedForecastConditionInput
  ) {
    deleteComposedForecast(input: $input, condition: $condition) {
      id
      __typename
    }
  }
`;

// Update a ComposedForecastDataSource
export const updateComposedForecastDataSourceCustom = /* GraphQL */ `
  mutation UpdateComposedForecastDataSource(
    $input: UpdateComposedForecastDataSourceInput!
    $condition: ModelComposedForecastDataSourceConditionInput
  ) {
    updateComposedForecastDataSource(input: $input, condition: $condition) {
      id
      composedForecastId
      sourceType
      sourceName
      sourceDescription
      processedModelOutputId
      # Intentionally NOT nesting the processedModelOutput object here — see
      # the same comment on createComposedForecastDataSourceCustom above.
      postgresTable
      postgresColumns
      postgresAggregation
      weight
      priority
      timeAlignment
      temporalResolution
      fallbackStrategy
      isActive
      lastFetchedAt
      lastFetchStatus
      dataQualityScore
      metadata
      dataOperations
      owner
      organizationId
      createdAt
      updatedAt
      __typename
    }
  }
`;

// Delete a ComposedForecastDataSource
export const deleteComposedForecastDataSourceCustom = /* GraphQL */ `
  mutation DeleteComposedForecastDataSource(
    $input: DeleteComposedForecastDataSourceInput!
    $condition: ModelComposedForecastDataSourceConditionInput
  ) {
    deleteComposedForecastDataSource(input: $input, condition: $condition) {
      id
      __typename
    }
  }
`;

// ===== ComposedForecastAssets (Composed Forecast <-> Asset join table) =====

// Create a single link row connecting one composed forecast to one asset.
export const createComposedForecastAssetsCustom = /* GraphQL */ `
  mutation CreateComposedForecastAssets(
    $input: CreateComposedForecastAssetsInput!
    $condition: ModelComposedForecastAssetsConditionInput
  ) {
    createComposedForecastAssets(input: $input, condition: $condition) {
      id
      composedForecastID
      assetID
      icon
      isDefault
      organizationId
      createdAt
      updatedAt
      __typename
    }
  }
`;

// Update an existing link row — used to change icon without losing the join row.
export const updateComposedForecastAssetsCustom = /* GraphQL */ `
  mutation UpdateComposedForecastAssets(
    $input: UpdateComposedForecastAssetsInput!
    $condition: ModelComposedForecastAssetsConditionInput
  ) {
    updateComposedForecastAssets(input: $input, condition: $condition) {
      id
      composedForecastID
      assetID
      icon
      isDefault
      organizationId
      createdAt
      updatedAt
      __typename
    }
  }
`;

// Delete a single link row by id.
export const deleteComposedForecastAssetsCustom = /* GraphQL */ `
  mutation DeleteComposedForecastAssets(
    $input: DeleteComposedForecastAssetsInput!
    $condition: ModelComposedForecastAssetsConditionInput
  ) {
    deleteComposedForecastAssets(input: $input, condition: $condition) {
      id
      __typename
    }
  }
`;

// List composed-forecast link rows for a single asset, with the linked
// ComposedForecast (and its data sources) nested in. Uses the byAsset GSI.
export const composedForecastAssetsByAssetCustom = /* GraphQL */ `
  query ComposedForecastAssetsByAsset(
    $assetID: ID!
    $composedForecastID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelComposedForecastAssetsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    composedForecastAssetsByAssetIDAndComposedForecastID(
      assetID: $assetID
      composedForecastID: $composedForecastID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        composedForecastID
        assetID
        icon
        isDefault
        organizationId
        composedForecast {
          id
          name
          description
          forecastType
          isActive
          dataSources {
            items {
              id
              composedForecastId
              sourceType
              sourceName
              sourceDescription
              processedModelOutputId
              processedModelOutput {
                id
                name
                description
                unit
                outputLocation
                active
                schemaId
                schema {
                  id
                  name
                  type
                  schemaType
                }
              }
              postgresTable
              postgresColumns
              postgresAggregation
              weight
              priority
              timeAlignment
              temporalResolution
              fallbackStrategy
              isActive
              metadata
              dataOperations
              __typename
            }
          }
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

// Author public profiles for Model Garden template cards. Only the fields the author row renders.
export const getPublicProfileForCard = /* GraphQL */ `
  query GetPublicProfile($id: ID!) {
    getPublicProfile(id: $id) {
      id
      displayName
      profilePictureUrl
      showDisplayName
      showProfilePicture
    }
  }
`;

export const getOrgPublicProfileForCard = /* GraphQL */ `
  query GetOrganizationPublicProfile($id: ID!) {
    getOrganizationPublicProfile(id: $id) {
      id
      displayName
      profilePictureUrl
      showDisplayName
      showProfilePicture
    }
  }
`;

// Owner/creator rows on model + template cards render a name and an avatar — getUserCustom pulls
// 24 fields including email and consent audit trails, which no card needs.
export const getUserForCard = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      name
      profilePictureUrl
    }
  }
`;

// Output params with only their newest ForecastRecord — one nested limit:1 per row beats a byParameter query per parameter
export const listOutputParamsWithLatestForecast = /* GraphQL */ `
  query ListProcessedModelOutputParams(
    $filter: ModelProcessedModelOutputParamFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProcessedModelOutputParams(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        active
        schemaId
        schema {
          id
          name
        }
        forecasts(sortDirection: DESC, limit: 1) {
          items {
            id
            forecastIssued
          }
        }
      }
      nextToken
    }
  }
`;

// Lean asset groups for the operations map; fetchGroupsAndNestedAssetsCustom drags in curves and models a cell never needs
export const listAssetGroupsForOperations = /* GraphQL */ `
  query ListAssetGroups(
    $filter: ModelAssetGroupFilterInput
    $limit: Int
    $nextToken: String
    $assetLimit: Int
  ) {
    listAssetGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        # Explicit: the nested connection otherwise takes AppSync's 100 default and drops the rest without a word
        assets(limit: $assetLimit) {
          items {
            id
            name
            lat
            lng
            icon
            description
            linkedProcessedModelSchemas {
              items {
                id
                processedModelSchemaID
                processedModelSchema {
                  id
                  name
                }
              }
            }
            linkedComposedForecasts {
              items {
                id
                composedForecastID
                composedForecast {
                  id
                  name
                }
              }
            }
          }
        }
      }
      nextToken
    }
  }
`;

// An asset group's assets with their composed-forecast and model link rows: just the ids and orgs needed to cascade a
// group's organization onto them (assetGroupSlice.cascadeAssetGroupOrganization).
export const assetOrganizationsByGroupCustom = /* GraphQL */ `
  query AssetOrganizationsByGroup($assetGroupId: ID!, $nextToken: String) {
    geoPointsByAssetGroupIdAndName(assetGroupId: $assetGroupId, limit: 1000, nextToken: $nextToken) {
      items {
        id
        organizationId
        linkedComposedForecasts(limit: 1000) {
          items {
            id
            organizationId
          }
        }
        linkedProcessedModelSchemas(limit: 1000) {
          items {
            id
            organizationId
          }
        }
      }
      nextToken
    }
  }
`;

export const updateProcessedModelSchemaAssetsOrganizationCustom = /* GraphQL */ `
  mutation UpdateProcessedModelSchemaAssetsOrganization($input: UpdateProcessedModelSchemaAssetsInput!) {
    updateProcessedModelSchemaAssets(input: $input) {
      id
      organizationId
    }
  }
`;

export const updateGeoPointOrganizationCustom = /* GraphQL */ `
  mutation UpdateGeoPointOrganization($input: UpdateGeoPointInput!) {
    updateGeoPoint(input: $input) {
      id
      organizationId
    }
  }
`;

// External forecast delivery calendar (utils/externalDelivery.ts): an output's forecasts by issue time, with when
// each first arrived (createdAt) and who sent it
export const deliveryRecordsByOutput = /* GraphQL */ `
  query DeliveryRecordsByOutput($parameterId: ID!, $forecastIssued: ModelStringKeyConditionInput, $sortDirection: ModelSortDirection, $limit: Int, $nextToken: String) {
    forecastRecordsByParameterIdAndForecastIssued(
      parameterId: $parameterId
      forecastIssued: $forecastIssued
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        forecastIssued
        s3Key
        createdAt
        uploadId
        uploadedBy
        source
      }
      nextToken
    }
  }
`;

// ...and the upload attempts into it since a time, for the ones that were rejected or are still being checked
export const deliveryUploadsByOutput = /* GraphQL */ `
  query DeliveryUploadsByOutput($outputParamId: ID!, $requestedAt: ModelStringKeyConditionInput, $sortDirection: ModelSortDirection, $limit: Int, $nextToken: String) {
    forecastUploadsByOutputParamIdAndRequestedAt(
      outputParamId: $outputParamId
      requestedAt: $requestedAt
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        source
        uploadedBy
        uploadedByEmail
        fileName
        issueTime
        forecastIssued
        validationErrors
        failureReason
        requestedAt
        receivedAt
        processedAt
      }
      nextToken
    }
  }
`;

// Every deployed model with what the Orchestration page needs: the outputs (graph ports), schemaFields (model_output
// links), runSchedule (row label) and the detail modals' fields, so a node click can hand them the same row.
export const listProcessedModelSchemasForOrchestration = /* GraphQL */ `
  query ListProcessedModelSchemasForOrchestration(
    $filter: ModelProcessedModelSchemaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProcessedModelSchemas(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        type
        version
        schemaType
        schemaFields
        runSchedule
        historicalSettings
        organizationId
        owner
        isActive
        activeStatus
        modelKind
        createdAt
        updatedAt
        outputs {
          items {
            id
            name
            description
            unit
            active
            schemaId
            storageMode
            targetDatasetId
          }
        }
      }
      nextToken
    }
  }
`;
